export default __webpack_public_path__ + "static/media/edpodia_logo.cc65197f.svg";